import { Provider } from 'react-redux';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
/**
 * React Redux DOM Factory
 */
export default class ReduxDomFactory {
    constructor(store = null) {
        this.root = null;
        this.store = store;
    }
    inject(module, props = {}, target) {
        if (target) {
            this.root = createRoot(target);
            this.root.render(React.createElement(Provider, { store: this.store, children: React.createElement(module, props) }));
        }
        else {
            console.warn('Target element is null or undefined. Cannot inject component');
        }
    }
    dispose(target) {
        if (target && this.root) {
            this.root.unmount();
        }
    }
}
//# sourceMappingURL=ReduxDomFactory.js.map